module.exports = __webpack_public_path__ + "static/media/Picto_Teams_AltyorHub.3efa3e06.svg";